import { parse } from 'date-fns';
import { IGerarRetornoSicoob, IDocumentoRetornoSicoob } from './types';
import { Banco } from '@/types/Boletos';
import { agruparRetorno } from '@/utils/agruparRetorno';

export function gerarRetorno({ dados }: IGerarRetornoSicoob) {
  try {
    const { arquivo } = dados;
    console.log(arquivo);
    const documentos: IDocumentoRetornoSicoob[] = [];

    for (let i = 0; i < arquivo.length; i++) {
      let linha = arquivo[i];

      const banco = linha.substring(0, 3);
      if (banco !== Banco.SICOOB) {
        continue;
      }

      const ocorrencia = linha.substring(15, 17);
      if (ocorrencia !== '06' && ocorrencia !== '17') {
        continue;
      }

      let segmento = linha.substring(13, 14);
      if (segmento === 'T') {
        const meu_numero = linha.substring(105, 130).trimEnd();
        let tipo_documento = 'INDEFINIDO';
        let id_documento = meu_numero;

        if (meu_numero.includes('-')) {
          const [tipo, id] = meu_numero.split('-');
          tipo_documento = tipo;
          id_documento = id;
        }

        const especie = tipo_documento.length ? tipo_documento : 'INDEFINIDO';
        linha = arquivo[++i];
        segmento = linha.substring(13, 14);
        if (segmento === 'U') {
          // Data de crédito no formato DDMMYYYY
          let dataCredito: Date;
          const dataCreditoString = linha.substring(145, 153);
          if (dataCreditoString && dataCreditoString !== '00000000') {
            dataCredito = parse(dataCreditoString, 'ddMMyyyy', new Date());
          } else {
            const dataOcorrenciaString = linha.substring(137, 145);
            dataCredito = parse(dataOcorrenciaString, 'ddMMyyyy', new Date());
          }

          const valorAbatimentoString = linha.substring(47, 62);
          const valorAbatimento = Number(valorAbatimentoString) / 100;

          const valorDescontoString = linha.substring(32, 47);
          const valorDesconto = Number(valorDescontoString) / 100;

          const valorPagoString = linha.substring(77, 92);
          const valorPago = Number(valorPagoString) / 100;

          const valorJurosString = linha.substring(17, 32);
          const valorJuros = Number(valorJurosString) / 100;

          const valorMulta = 0;
          const descontos = valorAbatimento + valorDesconto;
          const valorTotal = valorPago - valorJuros + descontos;

          const documento = {
            id_documento,
            especie,
            valor: valorPago,
            valor_multa: valorMulta,
            valor_juros: valorJuros,
            valor_desconto: valorDesconto,
            valor_total: valorTotal,
            data: dataCredito,
          };

          documentos.push(documento);
        }
      }
    }
    
    const documentoAgrupado = agruparRetorno<IDocumentoRetornoSicoob>(documentos);
    return documentoAgrupado;
  } catch (error) {
    console.log(error);
    return null;
  }
}
